<template>
    <div>
        <div v-if="!posts">
            <div class="spinner-border" role="status">
            </div>
        </div>
        <div v-else>
        <div class="container">
            <div class="row rssfeed mb-5 pb-4">
                <div class="col-md left post" v-for="post in posts" :key="post.guid">
                    <h2>{{ post.title }}</h2>
                    <div v-html="post.content" style="font-weight:200"></div>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>


<script>
    import Parser from 'rss-parser';

    export default {
        props: [
            'content',
        ],

        components: {
        },

        data() {
            return {
                posts: null,
            }
        },

        mounted() {
            this.fetchRSSFeed();
        },

        methods: {
            async fetchRSSFeed() {
                const parser = new Parser();
                const feed = await parser.parseString(this.content);
                this.posts = feed.items.slice(0, 3);
                console.log('feed', this.posts);
            }
        },
    }
</script>
